module.exports = __webpack_public_path__ + "static/img/icon1.7c6522c4.png";